export const DOCUMENT_TYPE = {
    GRAPH: 1,
    TABLE: 2,
    MAP: 3,
    CONTENT: 4
};
